import LazyFlag from 'components/LazyFlag/LazyFlag';
import Button from 'components/StyledButton/StyledButton';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
    display: block;
    margin: 0 auto;
    margin-bottom: 8px;
`;

export const StyledFlag = styled(LazyFlag)`
    display: inline;
    height: 14px;
    margin-right: 8px;
    margin-bottom: -2px;
`;
